import { getHistoryState, LoginCard } from "@indietabletop/appkit";
import { ViewContainer } from "../max-width-container";
import { MobileNavLayout } from "../mobile-nav-layout";

export function LoginPage() {
  return (
    <MobileNavLayout title="Login">
      <ViewContainer padding="small">
        <LoginCard
          description="Log into your Indie Tabletop Club account to enable backup and sync, quick start rules, and more!"
          defaultValues={{ email: getHistoryState()?.emailValue }}
        />
      </ViewContainer>
    </MobileNavLayout>
  );
}
